import {createContext, useContext} from 'react';

import {assert} from 'Asserts';

import {GraphQLFieldSelectorProps} from './GraphQLFieldSelector';

/** @package */
export interface GraphQLFieldSelectorContextOutput {
  getSortedFilteredFields: Required<GraphQLFieldSelectorProps>['getSortedFilteredFields'];
  graphQLSchema: GraphQLFieldSelectorProps['graphQLSchema'];
  logicalDepthLimit: Required<GraphQLFieldSelectorProps>['logicalDepthLimit'];
  noFieldsDisplayText: Required<GraphQLFieldSelectorProps['noFieldsDisplayText']>;
  getIsTypeDisabled: Required<GraphQLFieldSelectorProps>['getIsTypeDisabled'];
  renderCheckbox: GraphQLFieldSelectorProps['renderCheckbox'];
  renderExpandIcon: GraphQLFieldSelectorProps['renderExpandIcon'];
  renderFieldName: Required<GraphQLFieldSelectorProps>['renderFieldName'];
  renderTypeName: Required<GraphQLFieldSelectorProps>['renderTypeName'];
  renderFieldTypeIcon: GraphQLFieldSelectorProps['renderFieldTypeIcon'];
  getIsExpanded: (id: string, indentationLevel: number) => boolean;
  toggleIsExpanded: (id: string, indentationLevel: number) => void;
}

// Using vanilla React Context rather than `makeReactContext` since we're trying to future-package-proof this
// component, and a future package likely won't have access to `makeReactContext.`

/** @package */
export const GraphQLFieldSelectorContext =
  // eslint-disable-next-line benchlint/no-react-context
  createContext<null | GraphQLFieldSelectorContextOutput>(null);

/** @package */
export function useGraphQLFieldSelectorContext(): GraphQLFieldSelectorContextOutput {
  // eslint-disable-next-line benchlint/no-react-context
  const context = useContext(GraphQLFieldSelectorContext);
  assert(context != null, 'Tried to use GraphQLFieldSelector context without a Provider');
  return context;
}
